<!-- 消息条 -->
<template>
  <div id="message" v-if="message">
    <transition name="fade" v-on:after-leave="afterLeave">
      <div class="frame" v-if="show">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div :class="{rotate: img === '../assets/images/messageBar/ms03.png'}" :style="{background: `url(${img}) 50% 50% no-repeat`}"></div>
        <div>{{message}}</div>
      </div>
    </transition>
  </div>
</template>

<script>
import img1 from '../assets/images/messageBar/ms01.png'
import img2 from '../assets/images/messageBar/ms02.png'
import img3 from '../assets/images/messageBar/ms03.png'
export default {
  data() {
    return {
      show: false,
      message: "",
      img: img1
    };
  },
  watch: {},
  methods: {
    msg(msg, type, time) {
      this.show = true;
      this.message = msg;

      switch (type) {
        case 0:
          //
          this.img = "";
          break;
        case 1:
          // 警告
          this.img = img1;
          break;
        case 2:
          // 成功
          this.img = img2;
          break;
        case 3:
          // 转圈圈
          this.img = img3;
          break;
        default:
          this.img = img1;
          break;
      }

      if (type === 3) return;

      let _this = this;
      clearTimeout(window.messageBarTimer);
      window.messageBarTimer = setTimeout(function() {
        _this.show = false;
      }, time || 3000);
    },
    afterLeave() {
      //console.log(752)
    }
  },
  mounted() {
    window.$messageBar = this;
  }
};
</script>

<!-- <style scoped lang="scss"> -->
<style scoped >
#message{
  width: 100%;
  height: 35px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 999;

  .frame{
    min-width: 300px;
    height: 35px;
    background-color: #FFF6D3;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    >div:nth-child(1){
      width: 0;
      height: 0;
      border-left: 10px solid #FFF6D3;
      border-top: 17px solid transparent;
      position: absolute;
      right: -10px;
      bottom: 0;
    }
    >div:nth-child(2){
      width: 0;
      height: 0;
      border-left: 10px solid #FFF6D3;
      border-bottom: 17px solid transparent;
      position: absolute;
      right: -10px;
      top: 0;
    }
    >div:nth-child(3){
      width: 0;
      height: 0;
      border-right: 10px solid #FFF6D3;
      border-top: 17px solid transparent;
      position: absolute;
      left: -10px;
      bottom: 0;
    }
    >div:nth-child(4){
      width: 0;
      height: 0;
      border-right: 10px solid #FFF6D3;
      border-bottom: 17px solid transparent;
      position: absolute;
      left: -10px;
      top: 0;
    }
    >div:nth-child(5){
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }

}

.fade-enter-active {
  transition: all 0.3s ease;
}
.fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-active {
  transform: translateY(-40px);
}

.rotate {
  animation: myfirst 1s linear infinite;
}

@keyframes myfirst {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/messageBar.vue